import { render, staticRenderFns } from "./serviceFeeLists.vue?vue&type=template&id=2aff1f80&scoped=true&"
import script from "./serviceFeeLists.vue?vue&type=script&lang=js&"
export * from "./serviceFeeLists.vue?vue&type=script&lang=js&"
import style0 from "./serviceFeeLists.vue?vue&type=style&index=0&lang=css&"
import style1 from "./serviceFeeLists.vue?vue&type=style&index=1&id=2aff1f80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff1f80",
  null
  
)

export default component.exports